import { Component, inject, computed } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { AuthService } from '../../../core/services/auth.service';
import { NotificationService } from '../../../core/services/notification.service';

@Component({
  selector: 'app-navbar',
  imports: [
    RouterLink,
    RouterLinkActive,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatBadgeModule,
    MatDividerModule,
  ],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export class NavbarComponent {
  readonly auth = inject(AuthService);
  readonly notifications = inject(NotificationService);

  readonly displayName = computed(
    () => this.auth.profile()?.displayName || this.auth.profile()?.email || 'Neighbor',
  );

  readonly initials = computed(() => initialsFromName(this.displayName()));

  async logout(): Promise<void> {
    await this.auth.logout();
  }

  async markAllRead(): Promise<void> {
    const unread = this.notifications.notifications().filter((n) => !n.read).map((n) => n.id);
    if (unread.length) {
      await this.notifications.markAllRead(unread);
    }
  }
}

function initialsFromName(name: string): string {
  const cleaned = name.trim();
  if (!cleaned) return '?';

  if (cleaned.includes('@')) {
    return cleaned[0]!.toUpperCase();
  }

  const parts = cleaned.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0]!.slice(0, 1).toUpperCase();
  }

  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}
